import { render, staticRenderFns } from "./FilterableDatatable.vue?vue&type=template&id=dcbe2fd6&scoped=true&"
import script from "./FilterableDatatable.vue?vue&type=script&lang=ts&"
export * from "./FilterableDatatable.vue?vue&type=script&lang=ts&"
import style0 from "./FilterableDatatable.vue?vue&type=style&index=0&id=dcbe2fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbe2fd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VDataTable,VIcon,VMenu,VRow,VTextField,VTooltip})
